import { _t, barkApi } from '@bark/bark-core';

export function EliteProSubscribed() {
	/**
	 * Bark global
	 * @type {object}
	 */
	var Bark = (window.Bark = window.Bark || {});

	/**
	 * Bark.settings global
	 * @type {object}
	 */
	var settings = (Bark.settings = Bark.settings || {});

	/**
	 * Bark.settings.elite global
	 * @type {object}
	 */
	var elite = (settings.elitePro = settings.elitePro || {});

	/**
	 * Bark.settings.elite.stats
	 * @type {object}
	 */
	var stats = (elite.stats = elite.stats || {
		anyHidden: false,
	});

	/**
	 * Load queue
	 */
	var loadQueue;

	var statsBoxTemplate = null;

	var validStats = ['profile_views', 'listings', 'interactions'];

	var defaultStat = {
		profile_views: _t('seller_settings_elite-pro-subscribed:subscription-stats-title-1'),
		listings: _t('seller_settings_elite-pro-subscribed:subscription-stats-title-2'),
		interactions: _t('seller_settings_elite-pro-subscribed:subscription-stats-title-3'),
	};

	// @todo move to the API. Requires
	var defaultTitles = {
		profile_views: _t(
			'seller_settings_elite-pro-subscribed:subscription-stats-description-1',
		),
		listings: _t('seller_settings_elite-pro-subscribed:subscription-stats-description-2'),
		interactions: _t(
			'seller_settings_elite-pro-subscribed:subscription-stats-description-3',
		),
	};

	/**
	 * Build the page
	 */
	function buildPage() {
		var i;
		var key;
		var cur;
		var ytd;
		var mtd;
		var title;
		var icons = {
			profile_views: 'magnifier',
			listings: 'person',
			interactions: 'chat',
		};

		// if (stats.anyHidden) {
		//     $('.js-stats-summary-header').removeClass('d-block').addClass('d-none');
		//     $('.js-stats-available-on').text(stats.dateAvailable);
		//     return;
		// }

		if (!statsBoxTemplate) {
			statsBoxTemplate = window.Handlebars.compile(
				document.getElementById('elite-pro-stats-box').innerHTML,
			);
		}

		$('.js-stats-section').html('');

		for (i = 0; i < validStats.length; i++) {
			key = validStats[i];
			cur = stats[key];

			ytd = stats.anyHidden ? defaultStat[key] : cur.last_12_months || 0;
			mtd = stats.anyHidden ? 0 : cur.last_30_days || 0;
			title = stats.anyHidden ? defaultTitles[key] : cur.title;

			$('.js-stats-section').append(
				statsBoxTemplate({
					title: title,
					icon: icons[key],
					year_to_date: ytd,
					month_to_date: mtd,
				}),
			);
		}

		if (stats.anyHidden) {
			$('.js-stats-title').removeClass('order-md-1').addClass('order-md-2');
			$('.js-stats-value')
				.removeClass('order-md-2')
				.addClass('order-md-1 flex-basis-md-auto');
		}

		$('.js-my-performance-with-data')[stats.anyHidden ? 'addClass' : 'removeClass'](
			'd-none',
		);
		$('.js-my-performance-with-data')[stats.anyHidden ? 'removeClass' : 'addClass'](
			'd-block',
		);

		$('.js-my-performance-no-data')[stats.anyHidden ? 'removeClass' : 'addClass'](
			'd-none',
		);
		$('.js-my-performance-no-data')[stats.anyHidden ? 'addClass' : 'removeClass'](
			'd-block',
		);
	}

	/**
	 * Initialise the page
	 */
	function initPage() {
		var loadingThisTime = [];
		var x;

		if (loadQueue) {
			// Already loaded
			return;
		}

		loadQueue = {
			stats_profile_views: $.Deferred(),
			stats_listings: $.Deferred(),
			stats_interactions: $.Deferred(),
		};

		for (x in loadQueue) {
			loadingThisTime.push(loadQueue[x]);
		}

		elite.getStats('profile_views');
		elite.getStats('listings');
		elite.getStats('interactions');

		$.when
			.apply(undefined, loadingThisTime)
			.then(function () {
				buildPage();
				$('.waiting').removeClass('waiting');

				if (document.getElementById('elite-pro-discount-banner')) {
					if (window.EliteProDashboard) {
						window.EliteProDashboard.launchModule(
							'discount-banner',
							'elite-pro-discount-banner',
						);
					} else {
						tracking(
							'Elite Pro Discount Banner',
							'Elite pro dashboard react app not loaded'
						);
					}
				}
			})
			.fail(function () {
				$('.waiting').removeClass('waiting');
				$('.js-elite-pro-subscribed-content').addClass('d-none');
				$('.js-page-load-error').removeClass('d-none');
			});
	}

	elite.getStats = function (which) {
		var promiseKey = 'stats_' + which;

		if (!Bark.in_array(which, validStats)) {
			throw new { message: 'Invalid statistic ' + which }();
		}

		barkApi(
			'seller/subscriptions/stats?what=' + which,
			{},
			function (e) {
				stats[which] = e.data;
				stats.dateAvailable = e.data.stat_available_on;

				if (!e.data.is_visible) {
					stats.anyHidden = true;
				}

				loadQueue && loadQueue[promiseKey] && loadQueue[promiseKey].resolve();
			},
			function (error) {
				loadQueue && loadQueue[promiseKey] && loadQueue[promiseKey].reject(error);
			},
		);
	};

	initPage();
}
